import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useCallback,
} from 'react'

import { nanoid } from 'nanoid'
import { MRT_Localization_FR } from 'material-react-table/locales/fr'

import { BuilderContext } from '../Sandbox/components/store/store.Builder'
import FileDownloadIcon from '@mui/icons-material/FileDownload'
import Add from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import { ViewFormContext } from '../ViewForm/components/store/store.ViewForm'
import {
  collectFormAnswersData,
  downloadFile,
  duplicateFormResponse,
  deleteFormResponses,
} from '../../services/api'
import styles from './AnswersV3.module.css'

import Header from '../../components/Header/Header'
import { Button } from '@mui/material'
import { WebSocketListener } from '../Sandbox/components/webSocket/WebSocketListener'
import RowAction from './components/RowAction/RowAction'
import { toJS } from 'mobx'
import { Modal, Tooltip, Spin, Popconfirm } from 'antd'

import RenderForm from '../../components/RenderForm/RenderForm'
import ExportActionsCustom from './components/ExportActionsCustom/ExportActionsCustom'

import TopTitle from './components/TopTitle/TopTitle'
import { useNavigate } from 'react-router-dom'

import { MaterialReactTable, useMaterialReactTable } from 'material-react-table'

import { observer } from 'mobx-react-lite'

import { darken, useTheme } from '@mui/material'
import { SyncAltOutlined } from '@mui/icons-material'

const AnswersV3 = observer(() => {
  const renderCountRef = useRef(0)
  const navigate = useNavigate()
  renderCountRef.current += 1

  const theme = useTheme()

  const baseBackgroundColor =
    theme.palette.mode === 'dark' ? '#F3F4F4' : 'rgba(255, 255, 255, 1)'

  const [isIDEditing, setIsIDEditing] = useState()
  const [isLoadingData, setIsLoadingData] = useState(false)

  const [isExportModalOpen, setIsExportModalOpen] = useState(false)

  const openExportModal = () => setIsExportModalOpen(true)
  const closeExportModal = () => setIsExportModalOpen(false)

  const [includeLabels, setIncludeLabels] = useState(false)

  const IdentifiantForCanEditDjango = 'canEdit'

  const flag = useRef(false)
  const viewFormContext = useContext(ViewFormContext)
  const builderContext = useContext(BuilderContext)
  const answersStore = builderContext.AnswersStore

  useEffect(() => {
    if (flag.current === false) {
      const firstLoad = async () => {
        try {
          await answersStore.initializeState()
          await answersStore.loadData()
        } catch (e) {
          console.log('erreur', e)
        }
      }
      firstLoad()
    }

    return () => (flag.current = true)
  }, [navigate])

  useEffect(() => {
    console.log('quelque chose à changé')
  }, [builderContext.styleForm?.is_collaborative_mode])

  const IdentifiantForIDDjango = 'header_b0755b90-cc68-42ac-92c6-d165966e1cc9'

  /*************************************/
  // Fonction de state Material React Table
  const handleOnColumnFiltersChange = useCallback(
    (filtersOrUpdaterFn) => {
      let newFilters
      if (typeof filtersOrUpdaterFn === 'function') {
        newFilters = filtersOrUpdaterFn(answersStore.columnFilters)
      } else {
        newFilters = filtersOrUpdaterFn
      }
      answersStore.updateColumnFilters(newFilters)
    },
    [answersStore.columnFilters, answersStore.updateColumnFilters]
  )

  const handleOnColumnSizingChange = useCallback(
    (filtersOrUpdaterFn) => {
      let newFilters
      if (typeof filtersOrUpdaterFn === 'function') {
        newFilters = filtersOrUpdaterFn(answersStore.columnSizing)
      } else {
        newFilters = filtersOrUpdaterFn
      }
      answersStore.updateColumnSizing(newFilters)
    },
    [answersStore.columnSizing, answersStore.updateColumnSizing]
  )

  const handleOnPaginationChange = useCallback(
    (updater) => {
      if (typeof updater === 'function') {
        const { pageIndex, pageSize } = updater({
          pageIndex: answersStore.pagination.pageIndex,
          pageSize: answersStore.pagination.pageSize,
        })
        answersStore.updatePagination(pageIndex, pageSize)
      }
    },
    [answersStore.pagination, answersStore.updatePagination]
  )

  const handleOnColumnPinningChange = useCallback(
    (updater) => {
      if (typeof updater === 'function') {
        const { left, right } = updater({
          left: answersStore.columnPinning.left,
          right: answersStore.columnPinning.right,
        })

        answersStore.updateColumnPinning(left, right)
      }
    },
    [answersStore.columnPinning, answersStore.updateColumnPinning]
  )

  const handleOnRowSelectionChange = useCallback(
    (sortingUpdater) => {
      let newSortVal
      if (typeof sortingUpdater === 'function') {
        newSortVal = sortingUpdater(answersStore.rowSelection)
      } else {
        newSortVal = sortingUpdater
      }
      answersStore.updateRowSelection(newSortVal)
    },
    [answersStore.rowSelection, answersStore.updateRowSelection]
  )

  const handleOnColumnOrderChange = useCallback(
    (sortingUpdater) => {
      let newSortVal
      if (typeof sortingUpdater === 'function') {
        newSortVal = sortingUpdater(answersStore.columnOrder)
      } else {
        newSortVal = sortingUpdater
      }
      answersStore.updateColumnOrder(newSortVal)
    },
    [answersStore.columnOrder, answersStore.updateColumnOrder]
  )

  const handleOnSortingChange = useCallback(
    (sortingUpdater) => {
      let newSortVal
      if (typeof sortingUpdater === 'function') {
        newSortVal = sortingUpdater(answersStore.sorting)
      } else {
        newSortVal = sortingUpdater
      }
      answersStore.updateSortingState(newSortVal)
    },
    [answersStore.sorting, answersStore.updateSortingState]
  )

  const handleOnColumnVisibilityChange = useCallback(
    (sortingUpdater) => {
      let newSortVal
      if (typeof sortingUpdater === 'function') {
        newSortVal = sortingUpdater(answersStore.columnVisibility)
      } else {
        newSortVal = sortingUpdater
      }
      answersStore.updateColumnVisibility(newSortVal)
    },
    [answersStore.columnVisibility, answersStore.updateColumnVisibility]
  )
  // Fonction de state Material React Table
  /*************************************/

  /*************************************/
  // Fonction pour ajout / modification / suppression

  const handleAddNewResponse = async (rowData) => {
    setIsLoadingData(true)
    viewFormContext.toggleModalAddNewResponseOpen(true)

    const formData = {
      form__url_code: builderContext.url_code,
      // websocketID: ... // Inclure ceci si nécessaire
    }

    const checkPermission = async () => {
      await viewFormContext.initialisationGET(false, rowData)
      setIsLoadingData(false)
    }
    checkPermission()
    setIsIDEditing(rowData)
  }

  const handleEditClick = async (rowData) => {
    setIsLoadingData(true)
    viewFormContext.toggleModalVisibilityUpdateOpen(true)
    const formData = {
      form__url_code: builderContext.url_code,
      response__id: rowData,
      // websocketID: ... // Inclure ceci si nécessaire
    }

    const checkPermission = async () => {
      await viewFormContext.initialisationGET(true, rowData)
      setIsLoadingData(false)
    }
    checkPermission()
    setIsIDEditing(rowData)
  }

  const handleDeleteClick = async (rowData) => {
    console.log('rowData', rowData)
    try {
      await deleteFormResponses([rowData])
    } catch (error) {
      console.error('Erreur lors de la suppression :', error)
    }
  }

  const handleDuplicateClick = async (rowData) => {
    try {
      await duplicateFormResponse(rowData)
    } catch (error) {
      console.error('Erreur lors de la duplication :', error)
      if (error.response?.data?.error_code === 'AXIS_KEY_CONFLICT') {
        // Ouvre le modal d'édition avec l'ID de la réponse conflictuelle
        const conflictingResponseId =
          error.response?.data?.conflicting_response_id
        setIsLoadingData(true)
        viewFormContext.toggleModalDuplicateResponseOpen(true)

        const checkPermission = async () => {
          await viewFormContext.initialisationGET(true, conflictingResponseId)
          setIsLoadingData(false)
        }
        checkPermission()
      } else {
        // Gérer d'autres types d'erreurs ou afficher un message générique
        console.error(
          'Une erreur inattendue est survenue :',
          error.response?.data?.error || 'Erreur serveur'
        )
      }
    }
  }

  const handleDeleteRows = async (selectedRows) => {
    console.log('handleDeleteRows', selectedRows)
    const idsToDelete = selectedRows.map(
      (row) => row.original[answersStore.IdentifiantForIDDjango]
    )
    try {
      await deleteFormResponses(idsToDelete)
    } catch (error) {
      console.error('Erreur lors de la suppression des lignes :', error)
    }
  }

  // Fonction pour ajout / modification / suppression
  /*************************************/

  /*************************************/
  // Fonction gestion des exports

  // Fonction gestion des exports
  /*************************************/

  const data = useMemo(() => answersStore.data || [], [answersStore.data])

  const columns = useMemo(
    () => answersStore.headers || [],
    [answersStore.headers]
  )

  useEffect(() => {
    // Met à jour l'ordre des colonnes chaque fois que les colonnes changent
    const columnIds = columns.map((column) => column.id)
    handleOnColumnOrderChange(columnIds)
  }, [columns])

  const table = useMaterialReactTable({
    enableRowSelection: true,
    columns: columns,
    data: data,
    getRowId: (row) => row[IdentifiantForIDDjango],
    initialState: {
      showColumnFilters: true,
    },
    muiTablePaperProps: {
      sx: {
        // borderRadius: '10',
        // border: '1px dashed #e0e0e0',
      },
      style: {
        zIndex: answersStore.updateIsFullScreen ? 800 : undefined,
      },
    },

    muiTableContainerProps: {
      sx: { height: '100vh' },
    },
    manualFiltering: true,
    manualPagination: true,
    enableHiding: true,
    manualSorting: true,
    positionActionsColumn: 'last',
    enableRowSelection: true,
    enableColumnPinning: true,
    enableSelectAll: true,
    enableColumnResizing: true,
    columnResizeMode: 'onChange',
    positionToolbarAlertBanner: 'bottom',
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 15, 20, 25, 30, 50, 100, 150, 200],
    },
    enablePinning: true,
    enableColumnPinning: true,
    enableStickyHeader: true,
    localization: MRT_Localization_FR,
    onColumnFiltersChange: handleOnColumnFiltersChange,
    onShowColumnFiltersChange: answersStore.updateShowColumnFiltersChange,
    onShowGlobalFilterChange: answersStore.updateShowGlobalFilterChange,
    onRowSelectionChange: handleOnRowSelectionChange,
    onGlobalFilterChange: answersStore.handleSearchChange,
    onPaginationChange: handleOnPaginationChange,
    onDensityChange: answersStore.updateDensity,
    onSortingChange: handleOnSortingChange,
    onColumnSizingChange: handleOnColumnSizingChange,
    onColumnOrderChange: handleOnColumnOrderChange,
    onIsFullScreenChange: answersStore.updateIsFullScreen,
    onColumnVisibilityChange: handleOnColumnVisibilityChange,
    onColumnPinningChange: handleOnColumnPinningChange,
    rowCount: answersStore.totalRows,
    muiTableProps: {
      sx: {
        border: '1px solid rgba(224, 224, 224);',
      },
    },

    muiTableHeadCellProps: {
      sx: {
        border: '1px solid rgba(224, 224, 224);',
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: '1px solid rgba(224, 224, 224);',
      },
    },
    displayColumnDefOptions: {
      'mrt-row-select': {
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          align: 'center',
        },
      },
      'mrt-row-actions': {
        size: 160,
        enableResizing: false,
        enableHiding: false,
        muiTableHeadCellProps: {
          align: 'center',
        },
        muiTableBodyCellProps: {
          align: 'center',
        },
      },
      'mrt-row-numbers': {
        enableHiding: true,
      },
      'mrt-row-select': {
        enableHiding: true,
      },
    },
    muiTableBodyProps: {
      sx: (theme) => ({
        // Style pour les lignes sélectionnées
        '& tr[data-selected="true"] > td': {
          backgroundColor: '#ecf6fe',
        },

        // Style pour les lignes sélectionnées au survol
        '& tr[data-selected="true"]:hover > td': {
          backgroundColor: darken('#ecf6fe', 0.1), // ou une couleur plus foncée
        },
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
          {
            backgroundColor: '#F3F4F4',
          },

        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.1),
          },

        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
          {
            backgroundColor: '#FFFFFF',
          },

        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.1),
          },
      }),
    },
    enableRowActions: builderContext.styleForm?.is_collaborative_mode === true,
    renderTopToolbarCustomActions: (props, index) => (
      <div className={styles.liste_btn_toolbar}>
        <Tooltip title="Ajouter">
          <Button onClick={handleAddNewResponse} className={styles.creer_btn}>
            <Add className={styles.exporter_btn_icon} />
            <span className={styles.exporter_btn_text}>Ajouter</span>
          </Button>
        </Tooltip>

        <Tooltip title="Exporter">
          <Button onClick={openExportModal} className={styles.exporter_btn}>
            <FileDownloadIcon className={styles.exporter_btn_icon} />
            <span className={styles.exporter_btn_text}>Exporter</span>
          </Button>
        </Tooltip>

        <Tooltip title="Ce bouton permet d'afficher les libellés correspondant aux valeurs des champs à choix multiple">
          <Button
            onClick={() => {
              answersStore.toggleIncludeLabels()
            }}
            className={`${styles.exporter_btn} ${
              answersStore.includeLabels ? styles.active : ''
            }`}
          >
            <SyncAltOutlined />
            <span className={styles.exporter_btn_text}>Avec les libellés</span>
          </Button>
        </Tooltip>

        <Tooltip
          title="Supprimer"
          placement="bottom"
          color="black"
          key="Supprimer"
        >
          <Popconfirm
            title={`Êtes-vous sûr de vouloir supprimer ${
              table.getSelectedRowModel().rows.length === 1
                ? 'cet élément'
                : `ces ${table.getSelectedRowModel().rows.length} éléments`
            } ?`}
            onConfirm={() => handleDeleteRows(table.getSelectedRowModel().rows)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              className={styles.supp_btn}
              disabled={table.getSelectedRowModel().rows.length === 0}
            >
              <DeleteIcon className={styles.exporter_btn_icon} />
              <span className={styles.exporter_btn_text}>Supprimer</span>
            </Button>
          </Popconfirm>
        </Tooltip>
      </div>
    ),
    renderRowActions:
      builderContext.styleForm?.is_collaborative_mode === true
        ? (props) => (
            <RowAction
              {...props}
              canEdit={props.row.original[IdentifiantForCanEditDjango] === true}
              handleEditClick={handleEditClick}
              handleDuplicateClick={handleDuplicateClick}
              handleDeleteClick={handleDeleteClick}
            />
          )
        : null,
    state: {
      columnFilters: answersStore.columnFilters,
      columnVisibility: answersStore.columnVisibility,
      density: answersStore.density,
      globalFilter: answersStore.globalFilter,
      showColumnFilters: answersStore.showColumnFilters,
      showGlobalFilter: answersStore.showGlobalFilter,
      showProgressBars: answersStore.loading,
      isFullScreen: answersStore.isFullScreen,
      columnOrder: answersStore.columnOrder,
      rowSelection: answersStore.rowSelection,
      columnSizing: answersStore.columnSizing,
      columnPinning: {
        left: answersStore.columnPinning.left,
        right: answersStore.columnPinning.right,
      },
      pagination: {
        pageIndex: answersStore.pagination.pageIndex,
        pageSize: answersStore.pagination.pageSize,
      },
      sorting: answersStore.sorting,
    },
  })

  return (
    <div className={styles.page}>
      <Header isAnswersResponse={true} />

      <div className={styles.container}>
        <WebSocketListener />

        <TopTitle />

        <div className={styles.container__table}>
          <MaterialReactTable table={table} />

          <Modal
            title="Modifier les données"
            open={viewFormContext.modalVisibilityUpdateOpen}
            centered
            className={styles.modalUpdated}
            onCancel={() =>
              viewFormContext.toggleModalVisibilityUpdateOpen(false)
            }
            zIndex={1000}
            footer={null}
          >
            <div className={styles.modal_body}>
              {isLoadingData ? (
                <div className={styles.spin_div}>
                  <Spin size="large" />
                </div>
              ) : (
                <RenderForm
                  key={isIDEditing}
                  DataForm={viewFormContext.formInformations}
                  DataFields={viewFormContext.fields}
                  isUpdateSubmit={true}
                  isActiveSubmit={true}
                  editingFieldId={isIDEditing}
                  urlCode={viewFormContext.url_code}
                />
              )}
            </div>
          </Modal>

          <Modal
            title="Ajouter une nouvelle réponse"
            open={viewFormContext.modalAddNewResponseOpen}
            centered
            className={styles.modalUpdated}
            onCancel={() =>
              viewFormContext.toggleModalAddNewResponseOpen(false)
            }
            footer={null}
            zIndex={1000}
          >
            <div className={styles.modal_body}>
              {isLoadingData ? (
                <div className={styles.spin_div}>
                  <Spin size="large" />
                </div>
              ) : (
                <RenderForm
                  // key={nanoid()}
                  DataForm={viewFormContext.formInformations}
                  DataFields={viewFormContext.fields}
                  isUpdateSubmit={false}
                  isActiveSubmit={true}
                  isModalAddNewResponse={true}
                  urlCode={viewFormContext.url_code}
                />
              )}
            </div>
          </Modal>

          <Modal
            title="Dupliquer une réponse"
            open={viewFormContext.modalDuplicateResponseOpen}
            centered
            className={styles.modalUpdated}
            onCancel={() =>
              viewFormContext.toggleModalDuplicateResponseOpen(false)
            }
            footer={null}
            zIndex={1000}
          >
            <div className={styles.modal_body}>
              {isLoadingData ? (
                <div className={styles.spin_div}>
                  <Spin size="large" />
                </div>
              ) : (
                <RenderForm
                  // key={nanoid()}
                  DataForm={viewFormContext.formInformations}
                  DataFields={viewFormContext.fields}
                  isUpdateSubmit={false}
                  isActiveSubmit={true}
                  isModalAddNewResponse={true}
                  urlCode={viewFormContext.url_code}
                  isDuplicateConflict={true}
                />
              )}
            </div>
          </Modal>

          <Modal
            title="Exporter les données"
            open={isExportModalOpen}
            onCancel={closeExportModal}
            centered
            className={styles.modalUpdated}
            footer={null}
            zIndex={1000}
          >
            <ExportActionsCustom
              table={table}
              data={answersStore.data}
              closeModal={closeExportModal}
            />
          </Modal>
        </div>
      </div>
    </div>
  )
})

export default AnswersV3
